<template>
  <el-row :gutter="15">
    <el-col :span="24">
      <el-card shadow="never">
        <el-table
          v-loading="isLoading"
          :data="incidents"
          stripe
          class="w-100"
        >
          <el-table-column
            label="Name"
            prop="name"
            :formatter="row => row.name || '-'"
          />
          <el-table-column
            label="Description"
            prop="description"
            :formatter="row => row.description || '-'"
          />
          <el-table-column
            label="Type"
            prop="type.name"
            :formatter="row => row.type ? row.type.name : '-'"
          />
          <el-table-column
            label="Priority"
            prop="priority.name"
            :formatter="row => row.priority ? row.priority.name : '-'"
          />
          <el-table-column
            label="Status"
            prop="status.name"
            :formatter="row => row.status ? row.status.name : '-'"
          />
          <el-table-column
            label="Created At"
            prop="created_at"
            :formatter="row => $moment(row.created_at).fromNow() || '-'"
          />
          <el-table-column
            label="Actions"
            align="right"
            width="270px"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click.native="edit(scope.$index, scope.row)"
              >
                Edit
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <br>
        <div style="text-align: center;">
          <el-pagination
            :current-page.sync="incidents.page"
            :page-size.sync="incidents.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="incidents.total"
            @size-change="load()"
            @current-change="load()"
          />
        </div>
      </el-card>
    </el-col>
    <IncidentDialog
      ref="incidentDialog"
      :incident="selectedIncident"
      @save="load"
      @update="load"
    />
  </el-row>
</template>
<script>
import IncidentDialog from '@/components/Application/Configuration/IncidentDialog'
import { UPDATE } from '@/plugins/user'
export default {
  name: 'Incidents',
  components: {
    IncidentDialog
  },
  data () {
    return {
      title: 'Incidents',
      breadcrumb:
        {
          name: 'Incidents',
          route: { name: 'configuration-incidents' }
        },
      actions: [
        {
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.selectedIncident = new this.$sdk.incident()
            this.$refs.incidentDialog.showDialog()
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: () => this.load()
        }
      ],
      incidents: [],
      isLoading: false,
      selectedIncident: new this.$sdk.incident()
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, this.$sdk.incident)
    }
  },
  created () {
    this.load()
  },
  methods: {
    edit (scope, row) {
      this.selectedIncident = row.clone()
      this.$refs.incidentDialog.showDialog()
    },
    load () {
      this.isLoading = true
      this.$sdk.incident.list(builder => {
        builder.include = ['type', 'priority', 'status']
        builder.order = 'created_at:desc'
        builder.limit = 10
        builder.page = this.page
      })
        .then(res => {
          this.incidents = res
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style scoped>

</style>
